declare const STRIPE_PRICE_ID_25: string;
declare const STRIPE_PRICE_ID_100: string;
declare const STRIPE_PRICE_ID_200: string;
declare const STRIPE_PRICE_ID_500: string;

export interface CoinPack {
  priceId: string;
  priceUSD: number;
  coinAmount: number;
  best: boolean;
}

export const CoinPacks = [
  {
    priceId: STRIPE_PRICE_ID_500,
    priceUSD: 59.99,
    coinAmount: 500,
    best: true
  },
  {
    priceId: STRIPE_PRICE_ID_200,
    priceUSD: 34.99,
    coinAmount: 200,
    best: false
  },
  {
    priceId: STRIPE_PRICE_ID_100,
    priceUSD: 19.99,
    coinAmount: 100,
    best: false
  },
  {
    priceId: STRIPE_PRICE_ID_25,
    priceUSD: 9.99,
    coinAmount: 25,
    best: false
  },
];

export const getPackByPriceId = (priceId?: string): CoinPack | undefined => {
  if (!priceId) {
    return undefined;
  }

  for (const coinPack of CoinPacks) {
    if (coinPack.priceId === priceId) {
      return coinPack;
    }
  }

  return undefined;
}
